import { Directive, HostListener, Output } from '@angular/core';

@Directive({
  standalone: true,
  /* tslint:disable-next-line:directive-selector */
  selector: '[horizontalScrollDirective]'
})
export class HorizontalScrollDirective {
    @Output()
    public scrollLeftPosition = 0;

    @HostListener('scroll', ['$event'])
    private onScroll($event:any): void {
        this.scrollLeftPosition = $event.srcElement.scrollLeft;
    }
}
